import TabControl from './TabControl'

export default TabControl
